// Add the CSS to the automated workflow
import "../css/style.css"

// Import custom JS here...
import CookieBanner from "./cookie-banner"
import ProductFinder from "./ProductFinder"
import CartManager from "./CartManager"
import Checkout from "./Checkout"

var cookieBanner = new CookieBanner()
var productFinder = new ProductFinder()
var cartManager = new CartManager()
var checkout = new Checkout()
